module.exports = [
  'branchLocator',
  'foundationCalculator',
  'infoGraphicSquare',
  'infoGraphic',
];
